import React from 'react';
import { IProps } from './type';

const ExpandMoreIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 9L12 15L6 9"
        stroke={strokeColor ? strokeColor : "#212121"} />
    </svg>

  )
};

export default ExpandMoreIcon;
